export const GENERAL_SETTING_REQUEST  = 'GENERAL_SETTING_REQUEST';
export const SET_GENERAL_SETTING = 'SET_GENERAL_SETTING';
export const GENERAL_SETTING_REQUEST_FAILURE = 'GENERAL_SETTING_REQUEST_FAILURE';